import { useState, useEffect, useCallback } from 'react';
import { ExpandedAccordionsType, Evidences } from '../components/answer/types';

// Hook para manejar los acordeones
export const useAccordions = (evidences: Evidences) => {

  const initializeExpandedAccordions = useCallback(() => {
    const expandedAccordions: ExpandedAccordionsType = {};

    if (evidences.image && evidences.image.length > 0) {
      expandedAccordions.image = false;
    }
    if (evidences.video && evidences.video.length > 0) {
      expandedAccordions.video = false;
    }
    if (evidences.comment && evidences.comment.length > 0) {
      expandedAccordions.comment = false;
    }
    if (evidences.documents && evidences.documents.length > 0) {
      expandedAccordions.documents = false;
    }

    if (evidences.sign && evidences.sign.length > 0) {
      expandedAccordions.sign = false;
    }

    return expandedAccordions;
  }, [evidences]);

  const [expandedAccordions, setExpandedAccordions] = useState(initializeExpandedAccordions);
  const [expandAll, setExpandAll] = useState(false);


  // Función para alternar todos los acordeones
  const toggleAccordions = () => {
    setExpandAll((prevExpandAll) => {
      const newExpandAll = !prevExpandAll;
      setExpandedAccordions((prevState) => ({
        ...(prevState.image !== undefined && { image: newExpandAll }),
        ...(prevState.video !== undefined && { video: newExpandAll }),
        ...(prevState.comment !== undefined && { comment: newExpandAll }),
        ...(prevState.documents !== undefined && { documents: newExpandAll }),
        ...(prevState.sign !== undefined && { sign: newExpandAll }),
      }));
      return newExpandAll;
    });
  };

  // Función para alternar un acordeón específico
  const toggleAccordion = (type: keyof ExpandedAccordionsType) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  useEffect(() => {
    if (evidences) {  // Verifica que evidences exista
      const newExpandedAccordions = initializeExpandedAccordions(); // Llama a tu función para inicializarlo
      setExpandedAccordions(newExpandedAccordions);  // Actualiza el estado
    }
  }, [evidences]);

  useEffect(() => {
    // Verifica si todos los acordeones están expandidos o colapsados
    const allExpanded = Object.values(expandedAccordions).every(value => value === true);
    const allCollapsed = Object.values(expandedAccordions).every(value => value === false);

    if (allExpanded) {
      setExpandAll(true);
    } else if (allCollapsed) {
      setExpandAll(false);
    }
  }, [expandedAccordions]);

  return {
    expandedAccordions,
    expandAll,
    toggleAccordions,
    toggleAccordion,
    initializeExpandedAccordions,
    setExpandedAccordions,
  };
};